module.exports = __webpack_public_path__ + "img/上海市企业技术中心.e60fc85d.jpg";